import React from 'react'
import { PageHeaderProps } from './PageHeader.types'
import styles from './PageHeader.module.scss'
import cl from 'classnames'
import { PageAddressNavigator } from '../PageAddressNavigator'
import { Button } from '../Button'

const PageHeaderComponent = (props: PageHeaderProps) => {
  const {
    navSegments,
    buttons = [],
    className,
    style,
    buttonsContainerChildren,
    middleContainerChildren,
    middleContainerProps,
    secondLineContainerProps
  } = props

  return (
    <div className={cl(styles.header, className)} style={style}>
      <div className={styles.firstLine}>
        <PageAddressNavigator
          segments={navSegments}
        />
        <div className={styles.middleContainer} {...middleContainerProps}>
          {middleContainerChildren}
        </div>
        <div className={styles.headerButtons}>
          {buttonsContainerChildren}
          {buttons.map((buttonProps, index) =>
            <Button key={index} {...buttonProps} />
          )}
        </div>
      </div>
      <div {...secondLineContainerProps} />
    </div>
  )
}

const PageHeader = PageHeaderComponent
export { PageHeader }
